import _ from "lodash";
import React from "react";
import ReactDOMServer from "react-dom/server";

import {
  LearnerProfileDuotone,
  AssessmentsDuotone,
  ClipboardLinesDuotone,
  BiologyDuotone,
  SubjectGenericDuotone,
  AtlDuotone,
  KeyConceptDuotone,
  // ProgressReportDuotone,
  // KeyConceptDuotone,
  ProgressReportDuotone,
  FormativeAssessmentDuotone,
  WeightOutlined,
  CaretClosedFilled,
  CaretOpenedFilled,
  InformationOutlined,
  ClipboardBarGraphDuotone,
} from "@toddle-edu/ds-icons";
import { ASSESSMENT_TOOLS } from "@toddle-edu/common-utils";
import { Tag, Avatar, Tooltip, IconButton } from "@toddle-edu/ds-web";

import ConditionalWrapper from "Utils/ConditionalWrapper";
import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";

import { colors } from "Constants";
import ACLStore from "lib/aclStore";
import { GENERIC_TAGS_INFO } from "modules/Services";
import { pypElementMapping } from "Constants/plannerElementMappings";
import { getCriteriaList } from "StudentProgressSummary/modules/StudentProgressSummaryModule";
import {
  formatDate,
  getArchivedText,
  getTimeSince,
  getLabelWithArchivedText,
  getSubjectStandardWithCode,
  createRegex,
} from "Utils";
import { getFormattedStudentName } from "Utils/GetFormattedStudentName";
import { getUserSortOptions } from "Utils/GetFormattedUserName";

import classes from "../styles/CategoryWiseAssessments.scss";
import studentCategoryClasses from "StudentCategoryWiseAssessments/StudentCategoryWiseAssessments.scss";
import classNames from "classnames";
import {
  getIsIBGradeScaleTool,
  getStaffElementRemarkMessage,
  getIsEvaluationApplicable,
} from "ClassRoom/modules/utils";
import { getIsNewAssessmentSettingsEnabled } from "GradingSetup/modules/Utils";
import { getUniqlyCombinedGradesDetails } from "Course/modules/CourseGraphqlHelpers";

import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  PLANNER_ELEMENT_DP_CAS_STRANDS,
  ELEMENT_TYPE_ATL,
  ELEMENT_TYPE_CONCEPT,
  ELEMENT_TYPE_PYP_BENCHMARK,
  ELEMENT_TYPE_LEARNER_PROFILE,
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  GRADE_SCALE_TOOL,
  SCORE,
  COMMENT,
  SINGLE_POINT_RUBRIC,
  DP_MAX_GRADE,
  LOCAL_GRADE,
  FINAL_GRADE,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_DP_SUBJECT,
} from "Constants/stringConstants";
import { getIsEnabledExcusedStatusInAssignment } from "Utils/ACLStoreUtils";

export const PYP_ELEMENTS_ID_TYPE_ARRAY = [
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
];

export const getHlSlTagComponent = ({ label = "SL" }) => {
  return label ? (
    <Tag
      size={"xx-small"}
      color={_.get(GENERIC_TAGS_INFO, `${label}.color`, "teal")}
    >
      {label}
    </Tag>
  ) : null;
};

export const transformPypElementRatingData = ({
  elementsRating,
  selectedCriteriaSetId,
}) => {
  return _.reduce(
    elementsRating,
    (accumulator, item) => {
      const {
        studentId,
        ibPYPElementId,
        ibPYPElementType,
        academicCriteriaSetId,
        academicCriteriaValueId,
      } = item;

      // Filter out the academic criteria set id if it is not the selected one
      if (
        selectedCriteriaSetId &&
        selectedCriteriaSetId !== academicCriteriaSetId
      ) {
        return accumulator;
      }

      if (!accumulator[ibPYPElementId]) {
        accumulator[ibPYPElementId] = {};
      }
      accumulator[ibPYPElementId][studentId] = {
        academicCriteriaSetId,
        ibPYPElementType,
        academicCriteriaValueId,
      };
      return accumulator;
    },
    {}
  );
};

export const getSubjectIdsByCurriculum = ({ curriculumType, subjectIds }) => {
  switch (curriculumType) {
    case CURRICULUM_TYPE_UBD: {
      return [];
    }
    default: {
      return subjectIds;
    }
  }
};

export const learningGoalsProperties = {
  assessmentObjectives: {
    columnStyle: {
      width: "420px",
    },
    indentationLevel: 1,
  },
  subjectsStandards: {
    columnStyle: {
      width: "420px",
    },
    indentationLevel: 0,
  },
  atls: {
    columnStyle: {
      width: "420px",
    },
    indentationLevel: 1,
  },
  lpas: {
    columnStyle: {
      width: "272px",
    },
    indentationLevel: 1,
  },
  keyConcepts: {
    columnStyle: {
      width: "272px",
    },
    indentationLevel: 1,
  },
};

export const getAssociatedPlannerFiltersByRoute = ({
  elementType,
  selectedUnits,
  gradeIds,
  selectedGrades,
  subjectIds,
  selectedSubject,
  genericTags,
}) => {
  const plannerFilters = {
    associatedEntities: [],
    associatedParents: [],
  };
  if (!_.isEmpty(selectedUnits)) {
    plannerFilters.associatedEntities.push({
      ids: selectedUnits,
      type: "UNIT_PLAN",
    });
  }

  const addFilterToPlannerFilters = ({ ids, type, filterType }) => {
    if (!_.isEmpty(ids)) {
      switch (filterType) {
        case "associatedEntities": {
          plannerFilters.associatedEntities.push({
            ids,
            type,
          });
          break;
        }
        case "associatedParents": {
          plannerFilters.associatedParents.push({ ids, type });
          break;
        }
      }
    }
  };
  switch (elementType) {
    case ELEMENT_TYPE_MYP_ATL: {
      addFilterToPlannerFilters({
        ids: gradeIds,
        type: "GRADE",
        filterType: "associatedParents",
      });
      break;
    }
    case ELEMENT_TYPE_MYP_LEARNING_STANDARD: {
      addFilterToPlannerFilters({
        ids: subjectIds,
        type: "SUBJECT",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: gradeIds,
        type: "GRADE",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: genericTags,
        type: "GENERIC_TAG",
        filterType: "associatedEntities",
      });
      break;
    }
    case ELEMENT_TYPE_PYP_ATL:
    case ELEMENT_TYPE_PYP_KEY_CONCEPT:
    case ELEMENT_TYPE_PYP_LEARNER_PROFILE:
    case ELEMENT_TYPE_UBD_ATL: {
      addFilterToPlannerFilters({
        ids: selectedGrades,
        type: "GRADE",
        filterType: "associatedParents",
      });
      break;
    }
    case ELEMENT_TYPE_PYP_LEARNING_STANDARD: {
      addFilterToPlannerFilters({
        ids: selectedGrades,
        type: "GRADE",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: [selectedSubject],
        type: "SUBJECT",
        filterType: "associatedParents",
      });
      break;
    }
    case ELEMENT_TYPE_UBD_LEARNING_STANDARD: {
      addFilterToPlannerFilters({
        ids: selectedGrades,
        type: "GRADE",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: [selectedSubject],
        type: "SUBJECT",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: genericTags,
        type: "GENERIC_TAG",
        filterType: "associatedEntities",
      });
      break;
    }
    case ELEMENT_TYPE_DP_OBJECTIVES: {
      addFilterToPlannerFilters({
        ids: subjectIds,
        type: "SUBJECT",
        filterType: "associatedParents",
      });
      break;
    }
    case ELEMENT_TYPE_DP_SUBJECT_STANDARD: {
      addFilterToPlannerFilters({
        ids: selectedGrades,
        type: "GRADE",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: subjectIds,
        type: "SUBJECT",
        filterType: "associatedParents",
      });
      addFilterToPlannerFilters({
        ids: genericTags,
        type: "GENERIC_TAG",
        filterType: "associatedEntities",
      });
      break;
    }
    default: {
      break;
    }
  }
  const modifiedPlannerFilters = _.pickBy(
    plannerFilters,
    value => !_.isEmpty(value)
  );
  return modifiedPlannerFilters;
};

export const getElementTypeFromCurrentRoute = ({
  curriculumType,
  currentRoute,
}) => {
  let currentRouteToElementTypeMapping = {};
  let currentRouteToAliasElementTypeMapping = {};
  let currentRouteToRatingElementTypesMapping = {};

  switch (curriculumType) {
    case CURRICULUM_TYPE_PYP: {
      currentRouteToElementTypeMapping = {
        atls: ELEMENT_TYPE_PYP_ATL,
        keyConcepts: ELEMENT_TYPE_PYP_KEY_CONCEPT,
        learnerProfile: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
        subjectsStandards: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
      };
      currentRouteToAliasElementTypeMapping = {
        atls: ELEMENT_TYPE_ATL,
        keyConcepts: ELEMENT_TYPE_CONCEPT,
        learnerProfile: ELEMENT_TYPE_LEARNER_PROFILE,
        subjectsStandards: ELEMENT_TYPE_PYP_BENCHMARK,
      };
      break;
    }
    case CURRICULUM_TYPE_MYP: {
      currentRouteToElementTypeMapping = {
        atls: ELEMENT_TYPE_MYP_ATL,
        subjectsStandards: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
        lpas: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
      };
      currentRouteToRatingElementTypesMapping = {
        subjectsStandards: [
          ELEMENT_TYPE_MYP_SUBJECT,
          ELEMENT_TYPE_MYP_LEARNING_STANDARD,
        ],
      };

      break;
    }
    case CURRICULUM_TYPE_UBD: {
      currentRouteToElementTypeMapping = {
        atls: ELEMENT_TYPE_UBD_ATL,
        subjectsStandards: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
      };
      currentRouteToRatingElementTypesMapping = {
        subjectsStandards: [
          ELEMENT_TYPE_UBD_SUBJECT,
          ELEMENT_TYPE_UBD_LEARNING_STANDARD,
        ],
      };

      break;
    }
    case CURRICULUM_TYPE_DP: {
      currentRouteToElementTypeMapping = {
        atls: ELEMENT_TYPE_DP_ATL,
        lpas: ELEMENT_TYPE_DP_LEARNER_PROFILE,
        subjectsStandards: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
        assessmentObjectives: ELEMENT_TYPE_DP_OBJECTIVES,
      };
      currentRouteToRatingElementTypesMapping = {
        subjectsStandards: [
          ELEMENT_TYPE_DP_SUBJECT,
          ELEMENT_TYPE_DP_SUBJECT_STANDARD,
        ],
      };

      break;
    }
  }
  return {
    plannerElementType: currentRouteToElementTypeMapping[currentRoute],
    aliasPlannerElementType:
      currentRouteToAliasElementTypeMapping[currentRoute],
    ratingElementTypes: currentRouteToRatingElementTypesMapping[currentRoute],
  };
};

export const getFilterConfig = ({ t }) => {
  return [
    {
      key: "units",
      type: "checkListDropdown",
      showAllOption: true,
      showSelectedOptionsOnTop: false,
      filterButtonProps: { label: t("common:unit_plural") },
    },
    {
      key: "grades",
      type: "checkListDropdown",
      showAllOption: true,
      showSelectedOptionsOnTop: false,
      filterButtonProps: { label: t("common:grade_plural") },
      isDisabledDropdown: false,
    },
    {
      key: "students",
      type: "checkListDropdown",
      showAllOption: true,
      isSearchEnabled: true,
      showSelectedOptionsOnTop: false,
      placement: "bottomLeft",
      filterButtonProps: { label: t("common:student_plural") },
    },
    {
      key: "organizationTags",
      type: "checkListDropdown",
      showAllOption: true,
      isSearchEnabled: true,
      showSelectedOptionsOnTop: false,
      placement: "bottomLeft",
      filterButtonProps: { label: t("common:tag_plural") },
    },
    {
      key: "criteriaSet",
      type: "dropdown",
      overlayProps: { showSelection: true, selectionType: "radio" },
      filterButtonProps: { label: t("progressSummary:evaluation_criteria") },
    },
    {
      key: "terms",
      type: "dropdown",
      overlayProps: {
        showSelection: true,
        selectionType: "radio",
        style: { maxHeight: "280px", overflowY: "auto" },
      },
      filterButtonProps: { label: t("common:term_plural") },
    },
    {
      key: "subjects",
      type: "dropdown",
      overlayProps: { showSelection: true, selectionType: "radio" },
      filterButtonProps: {
        label: t("common:subject"),
        labelStyle: { maxWidth: "120px" },
      },
    },
    {
      key: "termWiseProgressReports",
      type: "radioGroupDropdown",
      placement: "bottomRight",
      filterButtonProps: {
        label: t("common:capitalize", { text: t("common:progress_reports") }),
      },
    },
  ];
};

export const getRatingHistoryDate = ({ publishedAt, t }) => {
  if (+formatDate({ date: publishedAt, format: "HHmmss" })) {
    return formatDate({ date: publishedAt, format: "D MMM" });
  } else {
    return getTimeSince(publishedAt, t);
  }
};

export const getDropDownLabelValue = ({ t, options, selectedOption }) => {
  const isItemGroup = _.some(options, option => _.get(option, "isItemGroup"));
  if (isItemGroup) {
    return getHeaderDropDownLabelValue({ t, options, selectedOption });
  }
  const selectedOptionObject = _.find(options, { key: selectedOption });
  return getArchivedText({
    name: _.get(selectedOptionObject, "label", t("common:na")),
    isArchived: _.get(selectedOptionObject, "isArchived", false),
    t,
  });
};

export const getHeaderDropDownLabelValue = ({ t, options, selectedOption }) => {
  // options is a item group so get its inner options
  const allOptions = _.flatten(_.map(options, "options"));
  const selectedOptionObject = _.find(allOptions, { key: selectedOption });

  return _.get(selectedOptionObject, "label", t("common:na"));
};

export const getHeaderFilters = ({ allFilters }) => {
  return _.reduce(
    allFilters,
    (accumulator, filter) => {
      const { location } = filter;
      if (_.isEqual(location, "header")) {
        accumulator.filterListWithOptionsData.push(filter);
      } else {
        accumulator.moreFilterListWithOptionsData.push(filter);
      }
      return accumulator;
    },
    { filterListWithOptionsData: [], moreFilterListWithOptionsData: [] }
  );
};

export const getCurriculumOverview = params => {
  const { iconSize = "small" } = params || {};

  return {
    IB_PYP: [
      {
        id: "ASSESSMENTS_AND_LEARNING_GOALS",
        label: "Assessments and learning goals",
        localeLabel: "progressSummary:assessments_and_learning_goals",
        subLabelLocale: "common:progress_summary_gradebook_subtext",
        children: [
          {
            id: 1,
            icon: <ClipboardLinesDuotone size={iconSize} color={"yellow"} />,
            label: "All assessments",
            localeLabel: "common:all_assessments",
            value: "allAssessments",
            color: colors.decorativeSurfaceThreeL,
            route: "allAssessments",
          },
          {
            id: 2,
            icon: <SubjectGenericDuotone size={iconSize} color={"yellow"} />,
            label: "Subjects standards",
            localeLabel: "common:sns",
            plannerElementType: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
            plannerElementTypeExport: ELEMENT_TYPE_PYP_BENCHMARK,
            elementColumnHeader: "common:knowledge",
            value: "subjectsStandards",
            type: "Progress_Summary",
            color: colors.decorativeSurfaceThreeL,
            route: "subjectsStandards",
            filterHeaderProps: {
              filterList: [
                { type: "subjects", location: "header" },
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
                { type: "organizationTags", location: "moreFilters" },
              ],
              searchBarProps: {
                locale: "common:sns",
                style: { width: "296px" },
              },
            },
          },
          {
            id: 3,
            icon: <AtlDuotone size={iconSize} color={"yellow"} />,
            label: "Approaches to learning",
            localeLabel: "common:atls_label",
            elementColumnHeader: "common:skill",
            localeDropdownLabel: "planningInsights:atl_insights",
            localeType: "planningInsights:type_insights_label",
            plannerElementType: ELEMENT_TYPE_PYP_ATL,
            plannerElementTypeExport: ELEMENT_TYPE_ATL,
            dropdownLabel: "ATL insights",
            value: "atls",
            type: "Progress_Summary",
            typeLocale: "common:insights",
            color: colors.decorativeSurfaceThreeL,
            route: "atls",
            filterHeaderProps: {
              filterList: [
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
              searchBarProps: { locale: "common:atl_skills" },
            },
          },
          {
            id: 4,
            icon: <KeyConceptDuotone size={iconSize} color={"yellow"} />,
            label: "Concepts",
            dropdownLabel: "Concept insights",
            localeLabel: "planningInsights:concepts",
            elementColumnHeader: "common:concepts_label",
            localeDropdownLabel: "planningInsights:concept_insight",
            localeType: "planningInsights:type_insights_label",
            plannerElementType: ELEMENT_TYPE_PYP_KEY_CONCEPT,
            plannerElementTypeExport: ELEMENT_TYPE_CONCEPT,
            value: "keyConcepts",
            type: "Progress_Summary",
            typeLocale: "common:insights",
            color: colors.decorativeSurfaceThreeL,
            route: "keyConcepts",
            filterHeaderProps: {
              filterList: [
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "students", location: "moreFilters" },
              ],
            },
          },
          {
            id: 5,
            icon: <LearnerProfileDuotone size={iconSize} color={"yellow"} />,
            label: "Learner profile attributes",
            dropdownLabel: "LPA insights",
            localeLabel: "planningInsights:lpa",
            elementColumnHeader: "planningInsights:lpa",
            localeDropdownLabel: "planningInsights:lpa_insights",
            localeType: "planningInsights:type_insights_label",
            plannerElementType: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
            plannerElementTypeExport: ELEMENT_TYPE_LEARNER_PROFILE,
            value: "learnerProfile",
            type: "Progress_Summary",
            typeLocale: "common:insights",
            color: colors.decorativeSurfaceThreeL,
            route: "learnerProfile",
            filterHeaderProps: {
              filterList: [
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "students", location: "moreFilters" },
              ],
            },
          },
        ],
      },
      {
        id: "INSIGHTS",
        label: "Insights",
        localeLabel: "common:insights",
        subLabelLocale: "common:progress_summary_insights_subtext",
        children: [
          // {
          //   id: 1,
          //   icon: <BiologyDuotone size={iconSize} color={"pink"} />,
          //   label: "Category-wise assessments",
          //   localeLabel: "common:category_wise_assessments",
          //   subLabelLocale: "Assessments insights",
          //   value: "Category-wise assessments",
          //   color: colors.decorativeSurfaceFourL,
          //   route: "category-wise-assessments",
          //   filterHeaderProps: {
          //     filterList: [
          //       { type: "terms", location: "header" },
          //       { type: "subjects", location: "header" },
          //       { type: "students", location: "moreFilters" },
          //     ],
          //   },
          // },
        ],
      },
    ],
    IB_MYP: [
      {
        id: "ASSESSMENTS_AND_LEARNING_GOALS",
        label: "Assessments and learning goals",
        localeLabel: "progressSummary:assessments_and_learning_goals",
        subLabelLocale: "common:progress_summary_gradebook_subtext",
        children: [
          {
            id: 1,
            icon: <ClipboardLinesDuotone size={iconSize} color={"yellow"} />,
            label: "All assessments",
            localeLabel: "common:all_assessments",
            value: "allAssessments",
            color: colors.decorativeSurfaceThreeL,
            route: "allAssessments",
          },
          {
            id: 2,
            icon: <SubjectGenericDuotone size={iconSize} color={"yellow"} />,
            label: "Subjects standards",
            localeLabel: "common:sns",
            elementColumnHeader: "common:sns",
            value: "subjectsStandards",
            type: "Progress_Summary",
            plannerElementType: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
            plannerElementTypeExport: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
            color: colors.decorativeSurfaceThreeL,
            route: "subjectsStandards",
            filterHeaderProps: {
              filterList: [
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
                { type: "organizationTags", location: "moreFilters" },
              ],
              searchBarProps: {
                locale: "common:sns",
                style: { width: "296px" },
              },
            },
          },
          {
            id: 3,
            icon: <AtlDuotone size={iconSize} color={"yellow"} />,
            label: "Approaches to learning",
            localeLabel: "common:atls_label",
            localeDropdownLabel: "planningInsights:atl_insights",
            elementColumnHeader: "common:skill_plural",
            localeType: "planningInsights:type_insights_label",
            dropdownLabel: "ATL insights",
            value: "atls",
            type: "Progress_Summary",
            typeLocale: "common:insights",
            plannerElementType: ELEMENT_TYPE_MYP_ATL,
            plannerElementTypeExport: ELEMENT_TYPE_MYP_ATL,
            color: colors.decorativeSurfaceThreeL,
            route: "atls",
            filterHeaderProps: {
              filterList: [
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
              searchBarProps: { locale: "common:atl_skills" },
            },
          },
          {
            id: 4,
            icon: <LearnerProfileDuotone size={iconSize} color={"yellow"} />,
            label: "Learner profile attributes",
            subLabel: "learner profile attribute",
            dropdownLabel: "Learner profile attributes",
            elementColumnHeader: "planningInsights:lpa",
            localeLabel: "planningInsights:lpa",
            localeType: "planningInsights:type_insights_label",
            value: "lpas",
            type: "Progress_Summary",
            plannerElementType: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
            plannerElementTypeExport: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
            plannerElementTypes: [ELEMENT_TYPE_MYP_LEARNER_PROFILE],
            color: colors.decorativeSurfaceThreeL,
            route: "lpas",
            fileName: "Learner profile attribute insights",
            filterHeaderProps: {
              filterList: [
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
            },
          },
        ],
      },
      {
        id: "INSIGHTS",
        label: "Insights",
        localeLabel: "common:insights",
        subLabelLocale: "common:progress_summary_insights_subtext",
        children: [
          // {
          //   id: 1,
          //   icon: <BiologyDuotone size={iconSize} color={"pink"} />,
          //   label: "Category-wise assessments",
          //   localeLabel: "common:category_wise_assessments",
          //   subLabelLocale: "Assessments insights",
          //   value: "Category-wise assessments",
          //   color: colors.decorativeSurfaceFourL,
          //   route: "category-wise-assessments",
          //   filterHeaderProps: {
          //     filterList: [
          //       { type: "terms", location: "header" },
          //       { type: "students", location: "moreFilters" },
          //     ],
          //   },
          // },
          {
            id: 2,
            icon: <ProgressReportDuotone size={iconSize} color={"pink"} />,
            label: "Progress report overview",
            localeLabel: "studentProgressSummary:progress_report_overview",
            subLabelLocale: "Progress report overview",
            value: "Progress report overview",
            color: colors.decorativeSurfaceFourL,
            route: "progress-report-overview",
          },
          // {
          //   id: 3,
          //   icon: <ClipboardLinesDuotone size={iconSize} color={"pink"} />,
          //   label: "Term overview",
          //   localeLabel: "common:term_overview",
          //   subLabelLocale: "Progress report insights",
          //   value: "Term overview",
          //   color: colors.decorativeSurfaceFourL,
          //   route: "term-overview",
          // },
        ],
      },
    ],
    UBD: [
      {
        id: "ASSESSMENTS_AND_LEARNING_GOALS",
        label: "Assessments and learning goals",
        localeLabel: "progressSummary:assessments_and_learning_goals",
        subLabelLocale: "common:progress_summary_gradebook_subtext",
        children: [
          {
            id: 1,
            icon: <ClipboardLinesDuotone size={iconSize} color={"yellow"} />,
            label: "All assessments",
            localeLabel: "common:all_assessments",
            value: "allAssessments",
            color: colors.decorativeSurfaceThreeL,
            route: "allAssessments",
          },
          {
            id: 2,
            icon: <SubjectGenericDuotone size={iconSize} color={"yellow"} />,
            label: "Subjects standards",
            localeLabel: "common:sns",
            elementColumnHeader: "common:sns",
            value: "subjectsStandards",
            type: "Progress_Summary",
            color: colors.decorativeSurfaceThreeL,
            route: "subjectsStandards",
            plannerElementType: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
            plannerElementTypeExport: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
            filterHeaderProps: {
              filterList: [
                { type: "subjects", location: "header" },
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
                { type: "organizationTags", location: "moreFilters" },
              ],
              searchBarProps: {
                locale: "common:sns",
                style: { width: "296px" },
              },
            },
          },
          {
            id: 3,
            icon: <AtlDuotone size={iconSize} color={"yellow"} />,
            label: "UbD Skills",
            localeLabel: "common:ubd_skills",
            elementColumnHeader: "common:skill_plural",
            localeDropdownLabel: "planningInsights:atl_insights",
            localeType: "planningInsights:type_insights_label",
            type: "Progress_Summary",
            typeLocale: "common:insights",
            plannerElementType: ELEMENT_TYPE_UBD_ATL,
            plannerElementTypeExport: ELEMENT_TYPE_UBD_ATL,
            color: colors.decorativeSurfaceThreeL,
            route: "atls",
            filterHeaderProps: {
              filterList: [
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
              searchBarProps: { locale: "common:ubd_skills" },
            },
          },
        ],
      },
      {
        id: "INSIGHTS",
        label: "Insights",
        localeLabel: "common:insights",
        subLabelLocale: "common:progress_summary_insights_subtext",
        children: [
          {
            id: 1,
            icon: <BiologyDuotone size={iconSize} color={"pink"} />,
            label: "Category-wise assessments",
            localeLabel: "common:category_wise_assessments",
            subLabelLocale: "Assessments insights",
            value: "Category-wise assessments",
            color: colors.decorativeSurfaceFourL,
            route: "category-wise-assessments",
            filterHeaderProps: {
              filterList: [
                { type: "terms", location: "header" },
                { type: "subjects", location: "header" },
                { type: "students", location: "header" },
              ],
            },
          },
          {
            id: 2,
            icon: <ClipboardLinesDuotone size={iconSize} color={"pink"} />,
            label: "Term overview",
            localeLabel: "common:term_overview",
            subLabelLocale: "Progress report insights",
            value: "Term overview",
            color: colors.decorativeSurfaceFourL,
            route: "termOverview",
            filterHeaderProps: {
              filterList: [
                { type: "termWiseProgressReports", location: "header" },
                { type: "students", location: "header" },
              ],
              filterSubtitle: "progressSummary:term_overview_subtitle",
            },
            headerButtonProps: {
              showDownload: false,
              showAddObservation: false,
            },
          },
        ],
      },
    ],
    IB_DP: [
      {
        id: "ASSESSMENTS_AND_LEARNING_GOALS",
        label: "Assessments and learning goals",
        localeLabel: "progressSummary:assessments_and_learning_goals",
        subLabelLocale: "common:progress_summary_gradebook_subtext",
        children: [
          {
            id: 1,
            icon: (
              <FormativeAssessmentDuotone size={iconSize} color={"yellow"} />
            ),
            label: "All assessments",
            localeLabel: "common:all_assessments",
            value: "allAssessments",
            color: colors.decorativeSurfaceThreeL,
            route: "allAssessments",
          },
          {
            id: 2,
            icon: <ClipboardBarGraphDuotone size={iconSize} color={"yellow"} />,
            label: "IB Grades across assessments",
            localeLabel: "common:IB_grade_across_assessments",
            value: "ibGradeAssessments",
            color: colors.decorativeSurfaceThreeL,
            route: "ibGradeAssessments",
            perm: "FeatureFlag:IBGradeClassSummary",
          },
          {
            id: 3,
            icon: <AssessmentsDuotone size={iconSize} color={"yellow"} />,
            label: "Assessment objectives",
            localeLabel: "common:objectives_label",
            elementColumnHeader: "common:objectives_label",
            localeType: "planningInsights:type_insights_label",
            type: "Progress_Summary",
            value: "assessmentObjectives",
            plannerElementTypes: [ELEMENT_TYPE_DP_OBJECTIVES],
            color: colors.decorativeSurfaceThreeL,
            route: "assessmentObjectives",
            plannerElementType: ELEMENT_TYPE_DP_OBJECTIVES,
            plannerElementTypeExport: ELEMENT_TYPE_DP_OBJECTIVES,
            filterHeaderProps: {
              filterList: [
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
              searchBarProps: {
                locale: "common:objectives_label",
                style: { width: "336px" },
              },
            },
          },
          {
            id: 4,
            icon: <SubjectGenericDuotone size={iconSize} color={"yellow"} />,
            label: "Subject standards",
            localeLabel: "common:sns",
            elementColumnHeader: "common:sns",
            value: "Subject standards",
            type: "Progress_Summary",
            plannerElementTypes: [ELEMENT_TYPE_DP_SUBJECT_STANDARD],
            plannerElementType: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
            plannerElementTypeExport: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
            color: colors.decorativeSurfaceThreeL,
            route: "subjectsStandards",
            filterHeaderProps: {
              filterList: [
                { type: "grades", location: "header" },
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
                { type: "organizationTags", location: "moreFilters" },
              ],
              searchBarProps: {
                locale: "common:sns",
                style: { width: "296px" },
              },
            },
          },
          {
            id: 5,
            icon: <AtlDuotone size={iconSize} color={"yellow"} />,
            label: "Approaches to learning",
            localeLabel: "common:atls_label",
            elementColumnHeader: "common:skill_plural",
            value: "atls",
            type: "Progress_Summary",
            plannerElementType: ELEMENT_TYPE_DP_ATL,
            plannerElementTypeExport: ELEMENT_TYPE_DP_ATL,
            plannerElementTypes: [
              ELEMENT_TYPE_DP_ATL,
              "DP_METACOGNITION_APPROACH",
              "DP_DIFFERENTIATION_APPROACH",
              "DP_LANGUAGE_AND_LEARNING_CONNECTION",
              "DP_TOK_CONNECTION",
              PLANNER_ELEMENT_DP_CAS_STRANDS,
            ],
            color: colors.decorativeSurfaceThreeL,
            route: "atls",
            filterHeaderProps: {
              filterList: [
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
            },
          },
          {
            id: 6,
            icon: <LearnerProfileDuotone size={iconSize} color={"yellow"} />,
            label: "Learner profile attributes",
            subLabel: "learner profile attribute",
            dropdownLabel: "Learner profile attributes",
            elementColumnHeader: "planningInsights:lpa",
            localeLabel: "planningInsights:lpa",
            localeType: "planningInsights:type_insights_label",
            value: "lpas",
            type: "Progress_Summary",
            plannerElementType: ELEMENT_TYPE_DP_LEARNER_PROFILE,
            plannerElementTypeExport: ELEMENT_TYPE_DP_LEARNER_PROFILE,
            plannerElementTypes: [ELEMENT_TYPE_DP_LEARNER_PROFILE],
            color: colors.decorativeSurfaceThreeL,
            route: "lpas",
            fileName: "Learner profile attribute insights",
            filterHeaderProps: {
              filterList: [
                { type: "criteriaSet", location: "header" },
                { type: "units", location: "moreFilters" },
                { type: "students", location: "moreFilters" },
              ],
            },
          },
        ],
      },
      {
        id: "INSIGHTS",
        label: "Insights",
        localeLabel: "common:insights",
        subLabelLocale: "common:progress_summary_insights_subtext",
        children: [
          {
            id: 1,
            icon: <BiologyDuotone size={iconSize} color={"pink"} />,
            label: "Category-wise assessments",
            localeLabel: "common:category_wise_assessments",
            subLabelLocale: "Assessments insights",
            value: "Category-wise assessments",
            color: colors.decorativeSurfaceFourL,
            route: "category-wise-assessments",
            filterHeaderProps: {
              filterList: [
                { type: "terms", location: "header" },
                { type: "students", location: "header" },
              ],
            },
          },
          {
            id: 2,
            icon: <ClipboardLinesDuotone size={iconSize} color={"pink"} />,
            label: "Term overview",
            localeLabel: "common:term_overview",
            subLabelLocale: "Progress report insights",
            value: "Term overview",
            color: colors.decorativeSurfaceFourL,
            route: "termOverview",
            filterHeaderProps: {
              filterList: [
                { type: "termWiseProgressReports", location: "header" },
                { type: "students", location: "moreFilters" },
              ],
              filterSubtitle: "progressSummary:term_overview_subtitle",
            },
            headerButtonProps: {
              showDownload: false,
              showAddObservation: false,
            },
          },
        ],
      },
    ],
  };
};

const getCurrentRouteConfig = ({ currentRoute, currentCurriculumType }) => {
  const CURRICULUM_OVERVIEW = getCurriculumOverview();

  const currentCurriculumOverview = CURRICULUM_OVERVIEW[currentCurriculumType];
  const allChildrenConfig = _.flatMap(currentCurriculumOverview, "children");
  const selectedRouteConfig = _.find(allChildrenConfig, {
    route: currentRoute,
  });
  return selectedRouteConfig;
};

export const getCurrentRouteConfigMemoized = _.memoize(
  params => getCurrentRouteConfig(params),
  params => JSON.stringify(params)
);

const _getCurrentCurriculumOverviewList = params => {
  const { t, currentCurriculumType, iconSize = "small" } = params || {};

  const CURRICULUM_OVERVIEW = getCurriculumOverview({
    iconSize,
  });
  const currentCurriculumOverview = CURRICULUM_OVERVIEW[currentCurriculumType];

  return _.map(currentCurriculumOverview, overview => {
    let children = _.filter(overview?.children, child => {
      if (_.has(child, "perm") && !ACLStore.can(child?.perm)) return false;
      return true;
    });

    const parentId = _.get(overview, "id", "");
    children = _.map(children, child => {
      const childId = _.get(child, "id", "");
      return {
        ...child,
        id: `${parentId}-${childId}`,
        label: child?.localeLabel ? t(child.localeLabel) : child?.label,
        type: child?.localeType ? t(child.localeType) : child?.type,
        plannerElementTypeExport: child?.plannerElementTypeExport,
        learningGoalType: child?.type,
      };
    });

    const updatedLabels = {
      label: overview?.localeLabel ? t(overview.localeLabel) : overview?.label,
      subLabel: overview?.subLabelLocale
        ? t(overview.subLabelLocale)
        : overview?.subLabel,
    };

    return {
      ...overview,
      ...updatedLabels,
      children,
    };
  });
};

export const getCurrentCurriculumOverviewList = _.memoize(
  params => _getCurrentCurriculumOverviewList(params),
  params => JSON.stringify(params)
);

export const getRatingParentTitle = ({ parentType, parent }) => {
  const parentTitle = _.get(parent, "title", "");
  const attachments = _.get(parent, "attachments", []);

  switch (parentType) {
    case "STUDENT_PROGRESS_REPORT": {
      return _.get(parent, "courseProgressReportTask.title", "") || "Untitled";
    }
    case "STUDENT_ASSESSMENT_EVALUATION": {
      return _.get(parent, "assessment.title.value", "") || "Untitled";
    }
    case "POST": {
      if (_.isEmpty(parentTitle) && !_.isEmpty(attachments)) {
        const noteAttachment = _.filter(
          attachments,
          attachment => _.get(attachment, "type", "") == "NOTE"
        );
        if (!_.isEmpty(noteAttachment)) {
          const noteLine = _.get(noteAttachment[0], "title", "Untitled");
          return _.isEmpty(noteLine) ? "Untitled" : noteLine;
        }
      }
      return parentTitle || "Untitled";
    }
    case "STUDENT_ASSIGNMENT": {
      return _.get(parent, "assignment.content.title.value", "") || "Untitled";
    }
    case "IMPORTED_ENTITY": {
      return _.get(parent, "name", "") || "Untitled";
    }
    default: {
      return "Observation";
    }
  }
};
export const getRatingHistoryParentType = ({ parentType, parent }) => {
  if (_.isEqual(parentType, "IMPORTED_ENTITY")) {
    return _.get(parent, "type", "");
  }
  return parentType;
};
export const getRatingParentIconInfo = ({ parentType, parent, t }) => {
  switch (parentType) {
    case "STUDENT_ASSIGNMENT":
    case "STUDENT_ASSESSMENT_EVALUATION": {
      const assessmentType =
        parentType === "STUDENT_ASSIGNMENT"
          ? _.get(parent, "assignment.content.assessmentType.value", {})
          : _.get(parent, "assessment.assessmentType.value", {});
      switch (assessmentType) {
        case "fmt":
          return {
            iconColor: "yellow",
            iconAssessmentTypeLabel: t("common:formative_assessment"),
          };
        case "smt":
          return {
            iconColor: "teal",
            iconAssessmentTypeLabel: t("common:summative_assessment"),
          };
        case "le":
          return {
            iconColor: "violet",
            iconAssessmentTypeLabel: t("common:le_label"),
          };
        case "qt":
          return {
            iconColor: "blue",
            iconAssessmentTypeLabel: t("common:quick_task"),
          };
        case "pri":
          return {
            iconAssessmentTypeLabel: t("classRoom:pre_assessment"),
          };
        case "pt":
          return {
            iconAssessmentTypeLabel: t("common:performance_task"),
          };
        case "se":
          return {
            iconAssessmentTypeLabel: t("common:supplementary_evidence"),
          };
        default:
          return {
            iconColor: "neutral",
            iconAssessmentTypeLabel: t("common:na"),
          };
      }
    }

    case "STUDENT_PROGRESS_REPORT":
      return { iconAssessmentTypeLabel: t("common:report_card") };
    case "POST":
      return { iconAssessmentTypeLabel: t("common:post") };
    default:
      return { iconAssessmentTypeLabel: "" };
  }
};

export const getTermWiseProgressReportsData = ({ terms }) => {
  const data = _.map(terms, term => {
    const id = _.get(term, "id", "");
    const label = _.get(term, "label", "");
    const dependentEntities = _.get(term, "dependentEntities", []);
    const options = _.map(dependentEntities, item => {
      const id = _.get(item, "id", "");
      const label = _.get(item, "title", "");
      return { id, label };
    });
    return { id, label, options };
  });
  return _.filter(data, term => {
    const options = _.get(term, "options", []);
    return _.size(options) > 0;
  });
};

export const getTermWiseProgressReportsDataMemoize = _.memoize(
  params => getTermWiseProgressReportsData(params),
  params => JSON.stringify(params)
);

const isAnyCriteriaGradeCommonInSelectedGrades = ({
  selectedGrades,
  gradeIds,
}) => {
  return _.some(gradeIds, id => _.find(selectedGrades, grade => grade === id));
};

const getCriteriaSetList = ({ criteriaSet, selectedGrades }) => {
  return _.reduce(
    criteriaSet,
    (criteriaSetList, { id, label, grades }) => {
      const gradeIds = _.map(grades, "id");
      if (
        isAnyCriteriaGradeCommonInSelectedGrades({ selectedGrades, gradeIds })
      ) {
        return [...criteriaSetList, { key: id, label }];
      } else {
        return criteriaSetList;
      }
    },
    []
  );
};

export const getCriteriaSetListMemoized = _.memoize(
  params => getCriteriaSetList(params),
  params => JSON.stringify(params)
);

const getStudents = ({ courseData, curriculumType }) => {
  return _.map(_.get(courseData, "userMap.edges", []), ({ node }) => {
    const user = _.get(node, "user", {});
    const tags = _.get(node, "tags", []);
    const isArchived = _.get(user, "isArchived", false);
    const isRemovedFromClass = _.get(node, "isRemovedFromClass", false);
    const tag = curriculumType == CURRICULUM_TYPE_DP && _.first(tags);
    return { ...user, tag, isArchived: isArchived || isRemovedFromClass };
  });
};

export const getStudentsMemoized = _.memoize(
  params => getStudents(params),
  params => JSON.stringify(params)
);

const getCurriculumGrades = ({ grades, curriculumId }) => {
  const gradesBasedOnCurriculumType = _.filter(grades, grade =>
    _.isEqual(_.get(grade, "curriculumProgram.id"), curriculumId)
  );
  return _.reduce(
    gradesBasedOnCurriculumType,
    (result, { name, id }) => {
      result.push({ label: name, value: id });
      return result;
    },
    []
  );
};

export const getCurriculumGradesMemoized = _.memoize(
  params => getCurriculumGrades(params),
  params => JSON.stringify(params)
);

export const getLeftComponentData = ({ searchBarProps, filterSubtitle }) => {
  if (searchBarProps) {
    return { data: searchBarProps };
  }
  if (filterSubtitle) {
    return { type: "subtitle", data: { filterSubtitle } };
  }
  return {};
};

export const getFilteredListWithOptionsDataAndType = ({
  filterList,
  filtersOptionsData,
}) =>
  _.map(filterList, filter => {
    const { type, location } = filter;
    return {
      key: type,
      optionsData: filtersOptionsData[type],
      location,
    };
  });

const getCategoryWiseAssessments = ({ academicCriteriaSets }) => {
  const categoryWiseAssessments = [];
  _.forEach(academicCriteriaSets, academicCriteriaSet => {
    _.forEach(
      _.get(academicCriteriaSet, "academicCriteriaValues", []),
      academicCriteriaValue => {
        const updatedAcademicCriteriaValue = _.cloneDeep(academicCriteriaValue);
        const assignments = _.get(academicCriteriaValue, "assignments", []);
        const scoreEnabledAssignments = [];
        _.forEach(assignments, assignment => {
          const { maxScore, isScoreEnabled } = getScoreDetailsMemoize({
            assessmentTools: _.get(assignment, "content.assessmentTools", []),
          });
          if (isScoreEnabled && maxScore) {
            scoreEnabledAssignments.push(assignment);
          }
        });
        if (!_.isEmpty(scoreEnabledAssignments)) {
          categoryWiseAssessments.push({
            ...updatedAcademicCriteriaValue,
            assignments: scoreEnabledAssignments,
            academicCriteriaSetId: _.get(academicCriteriaSet, "id"),
            isShowGradeBoundaries: _.get(
              academicCriteriaSet,
              "isShowGradeBoundaries",
              false
            ),
          });
        }
      }
    );
  });
  return categoryWiseAssessments;
};

export const getCategoryWiseAssessmentsMemoized = _.memoize(
  getCategoryWiseAssessments,
  params => JSON.stringify(params)
);

const getStudentCategoryWiseAssessments = ({ academicCriteriaSets }) => {
  const categoryWiseAssessments = [];
  _.forEach(academicCriteriaSets, academicCriteriaSet => {
    _.forEach(
      _.get(academicCriteriaSet, "academicCriteriaValues", []),
      academicCriteriaValue => {
        const updatedAcademicCriteriaValue = academicCriteriaValue;
        const assignments = _.get(academicCriteriaValue, "assignments", []);

        const scoreEnabledAssignments = _.filter(assignments, assignment => {
          const { maxScore, isScoreEnabled } = getScoreDetailsMemoize({
            assessmentTools: _.get(assignment, "content.assessmentTools", []),
          });
          return isScoreEnabled && maxScore;
        });

        categoryWiseAssessments.push({
          ...updatedAcademicCriteriaValue,
          assignments: scoreEnabledAssignments,
          academicCriteriaSetId: _.get(academicCriteriaSet, "id"),
          isShowGradeBoundaries: _.get(
            academicCriteriaSet,
            "isShowGradeBoundaries",
            false
          ),
        });
      }
    );
  });
  return categoryWiseAssessments;
};

export const getStudentCategoryWiseAssessmentsMemoized = _.memoize(
  getStudentCategoryWiseAssessments,
  params => JSON.stringify(params)
);

const assignmentTitleClass = classNames(classes.assignmentTitle, "text-body-2");
const assignmentTitleSubtextClass = classNames(
  classes.assignmentTitleSubtext,
  "text-body-3"
);

const styles = {
  studentHeader: { backgroundColor: colors.surfaceSubtle, width: "260px" },
  studentName: { whiteSpace: "pre-wrap" },
  studentCell: { backgroundColor: colors.surfaceWhite },
  greyCell: { backgroundColor: colors.surfaceSubtle },
  totalHeader: {
    backgroundColor: colors.surfaceSubtle,
    textAlign: "center",
    width: "140px",
  },
  cursorDefault: {
    cursor: "default",
  },
  centerAlignWithGap: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  tooltipStyle: { maxWidth: "216px" },
};

const getCategorySubtext = _.memoize(
  ({ orderedScoreValues, isCurriculumDP, conditionalPercentage }) => {
    return _.join(
      _.map(orderedScoreValues, scoreValue => {
        const genericTagLabel = _.get(scoreValue, "genericTag.label", "");
        const value = _.get(scoreValue, "value", "");
        const prefix = isCurriculumDP ? `${genericTagLabel} - ` : "";
        return `${prefix}${value}${conditionalPercentage}`;
      }),
      ", "
    );
  },
  params => JSON.stringify(params)
);

const _getCategoryWiseAssessmentsTableHeaders = ({
  t,
  categoryWiseAssessments,
  isCurriculumDP,
  isCurriculumUBD,
  isScoreV2,
  isAbsoluteWeightageType,
  categoryTotalDisplayType,
  localGradeType,
  isCustomWeights,
  onClickAssessment,
}) => {
  const conditionalPercentage = isAbsoluteWeightageType ? "" : "%";

  const tableHeaders = [];

  _.forEach(categoryWiseAssessments, categoryWiseAssessment => {
    const categoryId = _.get(categoryWiseAssessment, "id");
    const categoryLabel = _.get(categoryWiseAssessment, "label", "");
    const scoreValues = _.get(categoryWiseAssessment, "scoreValues", []);
    const orderedScoreValues = _.orderBy(
      scoreValues,
      "genericTag.label",
      "desc"
    );
    const gradeBoundaries = _.get(
      categoryWiseAssessment,
      "gradeBoundaries",
      []
    );
    const categorySubtext = getCategorySubtext({
      orderedScoreValues,
      isCurriculumDP,
      conditionalPercentage,
    });
    const assignments = _.cloneDeep(
      _.get(categoryWiseAssessment, "assignments", [])
    );

    const isShowGradeBoundaries = _.get(
      categoryWiseAssessment,
      "isShowGradeBoundaries",
      false
    );

    if (
      isCurriculumDP &&
      isScoreV2 &&
      isShowGradeBoundaries &&
      !_.isEmpty(gradeBoundaries)
    ) {
      assignments?.push({
        id: `${categoryId}-gradeBoundary`,
        title: t("academicSetup:category_grade"),
        subtitle: `1-7 ${_.toLower(t("academicSetup:scale"))}`,
        backgroundColor: colors.surfaceSubtle,
      });
    }

    assignments?.push({
      id: `${categoryId}-total`,
      title: t("common:total"),
      hideSubtitle: categoryTotalDisplayType === "WEIGHT",
      subtitle: t("common:in_label", { label: "%" }),
      backgroundColor: colors.surfaceSubtle,
    });

    const headerItem = {
      key: categoryId,
      entity: categoryId,
      parent: "root",
      children: [],
      level: 0,
      value: (
        <div className={classes.categoryLabelContainer}>
          <div className={assignmentTitleClass}>{categoryLabel}</div>
          <div className={assignmentTitleSubtextClass}>{categorySubtext}</div>
        </div>
      ),
      alignment: "center",
      style: styles.greyCell,
    };

    _.forEach(assignments, assignment => {
      const assignmentId = _.get(assignment, "id");
      const assignmentTitle = _.get(assignment, "content.title.value", "");
      const _weightage = _.get(assignment, "content.weightage");
      const weightage = _.isFinite(_weightage) ? _weightage : 100;
      const { maxScore } = getScoreDetailsMemoize({
        assessmentTools: _.get(assignment, "content.assessmentTools", []),
      });
      const isAssignment = !_.isEmpty(assignmentTitle);
      const onClickAssessmentTitle = () => {
        if (isAssignment) {
          onClickAssessment(assignmentId);
        }
      };
      const assignmentTitleClasses = classNames(assignmentTitleClass, {
        [classes.clickableAssignmentTitle]: isAssignment,
        [classes.titleWithSortIcon]: !isAssignment,
      });
      headerItem.children.push(assignmentId);
      tableHeaders.push({
        key: assignmentId,
        entity: assignmentId,
        parent: categoryId,
        children: [],
        level: 1,
        style: {
          textAlign: "center",
          backgroundColor: assignment?.backgroundColor ?? colors.surfaceWhite,
          width: "140px",
        },
        value: (
          <div className={classes.assignmentNameContainer}>
            <ConditionalWrapper
              type="wrapperAsElement"
              wrapper={<Tooltip tooltip={assignmentTitle} placement={"top"} />}
              condition={isAssignment}
            >
              <div
                className={assignmentTitleClasses}
                onClick={onClickAssessmentTitle}
              >
                {assignment?.title || assignmentTitle}
              </div>
            </ConditionalWrapper>
            {!assignment?.hideSubtitle ? (
              <div className={classes.assignmentSubtextCon}>
                <div className={assignmentTitleSubtextClass}>
                  {assignment?.subtitle ?? `${maxScore} pts`}
                </div>
                {isAssignment && isCustomWeights ? (
                  <>
                    <div className={classes.dot} />
                    <div className={classes.weightageContainer}>
                      <WeightOutlined size="xxxx-small" variant="subtle" />
                      <div className={assignmentTitleSubtextClass}>
                        {weightage}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
          </div>
        ),
        sortType: !isAssignment ? "toggle" : "",
      });
    });
    tableHeaders.push(headerItem);
  });

  const totalsHeaderItem = {
    key: "TOTALS",
    entity: "TOTALS",
    parent: "root",
    children: [],
    level: 0,
    value: <div className="text-body-1">{t("common:totals")}</div>,
    alignment: "center",
    style: styles.greyCell,
  };

  const totalsItems = [
    {
      id: "FINAL_SCORE",
      label: t("common:term_total"),
      subtitle: "100%",
      entity: "FINAL_SCORE",
    },
  ];

  if (isCurriculumDP && isScoreV2) {
    totalsItems.push({
      id: "FINAL_GRADE",
      label: t("common:final_grade"),
      subtitle: "1-7 scale",
      entity: "FINAL_GRADE",
    });
  }

  if (isScoreV2) {
    totalsItems.push({
      id: "LOCAL_GRADE",
      label: t("common:local_grade_text"),
      entity:
        localGradeType === "WEIGHTED_SCORE" || isCurriculumUBD
          ? "FINAL_SCORE"
          : "FINAL_GRADE",
    });
  }

  const assignmentNameConClass = classNames(
    classes.assignmentNameContainer,
    classes.titleWithSortIcon
  );

  _.forEach(totalsItems, item => {
    const itemId = _.get(item, "id");
    const entity = _.get(item, "entity");
    tableHeaders.push({
      key: itemId,
      entity: entity,
      parent: "TOTALS",
      children: [],
      level: 1,
      style: styles.totalHeader,
      value: (
        <div className={assignmentNameConClass}>
          <div className={assignmentTitleClass}>{item?.label}</div>
          {item?.subtitle ? (
            <div className={assignmentTitleSubtextClass}>{item.subtitle}</div>
          ) : null}
        </div>
      ),
      sortType: "toggle",
    });
    totalsHeaderItem.children.push(itemId);
  });

  tableHeaders.push(totalsHeaderItem);

  return [
    {
      key: "student",
      entity: "STUDENT",
      parent: "root",
      children: [],
      level: 0,
      isSticky: true,
      value: <div className="text-body-1">{t("common:student")}</div>,
      style: styles.studentHeader,
      sortType: "dropdown",
      sortOptions: [
        {
          key: "FIRST_NAME_AZ",
          label: "First name A-Z",
          sortEntity: "FIRST_NAME_A_Z",
          direction: "ASC",
        },
        {
          key: "FIRST_NAME_ZA",
          label: "First name Z-A",
          sortEntity: "FIRST_NAME_Z_A",
          direction: "DESC",
        },
        {
          key: "LAST_NAME_AZ",
          label: "Last name A-Z",
          sortEntity: "LAST_NAME_A_Z",
          direction: "ASC",
        },
        {
          key: "LAST_NAME_ZA",
          label: "Last name Z-A",
          sortEntity: "LAST_NAME_Z_A",
          direction: "DESC",
        },
      ],
    },
    ...tableHeaders,
  ];
};

export const getCategoryWiseAssessmentsTableHeaders = _.memoize(
  _getCategoryWiseAssessmentsTableHeaders,
  params => JSON.stringify(params)
);

const getStudentCellData = _.memoize(
  ({ student, isCurriculumDP, tableSortedBy }) => {
    const { id, profileImage, tag = {} } = student || {};
    const studentName = getFormattedStudentName({
      student,
      orderBy: tableSortedBy,
    });

    return (
      <div className={classes.studentContainer}>
        <div className={classes.studentProfileContainer}>
          <div className={classes.avatarContainer}>
            <Avatar
              name={studentName}
              src={profileImage}
              id={id}
              shade={"light"}
            />
          </div>
          <div className="text-body-1" style={styles.studentName}>
            {studentName}
          </div>
        </div>
        {isCurriculumDP
          ? getHlSlTagComponent({ label: _.get(tag, "label", "") })
          : null}
      </div>
    );
  },
  params => JSON.stringify(params)
);

const getStudentAssignmentScore = _.memoize(
  ({ studentWiseRatings, studentAssignment }) => {
    const studentScore = _.find(
      studentWiseRatings,
      rating => _.get(rating, "parent.id") === _.get(studentAssignment, "id")
    );
    return _.round(parseFloat(_.get(studentScore, "value", 0)), 2);
  },
  params => JSON.stringify(params)
);

const getStudentAssignmentValue = _.memoize(
  ({ studentAssignment, types }) => {
    const ratings = _.get(studentAssignment, "ibPYPElementRatings", []);
    const grade = _.find(ratings, rating =>
      _.includes(types, _.get(rating, "ibPYPElementType", ""))
    );
    return _.get(grade, "value", "");
  },
  params => JSON.stringify(params)
);

const getCategoryWiseStudentFinalScore = _.memoize(
  ({ studentWiseRatings, categoryId, ibPYPElementType }) => {
    return _.get(
      _.find(
        studentWiseRatings,
        rating =>
          _.get(rating, "ibPYPElementType") === ibPYPElementType &&
          _.get(rating, "academicCriteriaValue.id") === categoryId &&
          _.get(rating, "academicCriteriaSet.criteriaType") ===
            "ASSESSMENT_CATEGORY"
      ),
      "value",
      0
    );
  },
  params => JSON.stringify(params)
);

const getCategoryWiseStudentFinalGrade = _.memoize(
  ({
    studentWiseRatings,
    categoryId,
    ibPYPElementType,
    criteriaType = "GRADE_BOUNDARY",
  }) => {
    const categoryGradeRatings = _.filter(studentWiseRatings, rating => {
      return (
        _.get(rating, "ibPYPElementType") === ibPYPElementType &&
        _.get(rating, "category.id") === categoryId &&
        _.get(rating, "academicCriteriaSet.criteriaType") === criteriaType
      );
    });

    const overridenRating = _.find(categoryGradeRatings, {
      isComputedRating: false,
    });
    const computedRating = _.find(categoryGradeRatings, {
      isComputedRating: true,
    });
    const rating = overridenRating ?? computedRating;
    return _.get(rating, "value", "-");
  },
  params => JSON.stringify(params)
);

const getTotalStudentScore = _.memoize(
  ({ studentWiseRatings, type, ibPYPElementType }) => {
    const ratings = _.filter(studentWiseRatings, rating => {
      let condition =
        _.get(rating, "ibPYPElementType") === ibPYPElementType &&
        _.get(rating, "academicCriteriaSet.criteriaType") === type;

      if (type === "FINAL_GRADE") {
        condition =
          condition &&
          _.get(rating, "isComputedRating") &&
          _.get(rating, "academicCriteriaSet.subType") === "SUBJECT";
      }

      if (_.includes([FINAL_GRADE, LOCAL_GRADE], type)) {
        condition = condition && _.isNil(_.get(rating, "category.id"));
      }

      return condition;
    });

    const overridenRating = _.find(ratings, {
      isComputedRating: false,
    });
    const computedRating = _.find(ratings, {
      isComputedRating: true,
    });
    const rating = overridenRating ?? computedRating;

    const defaultValue = type === "FINAL_SCORE" ? 0 : "-";

    return (
      _.get(rating, "value", defaultValue) ||
      _.get(rating, "academicCriteriaValue.label", defaultValue)
    );
  },
  params => JSON.stringify(params)
);

const getEditedFinalGrade = _.memoize(
  ({ studentWiseRatings, type, ibPYPElementType }) => {
    return _.get(
      _.find(studentWiseRatings, rating => {
        return (
          _.get(rating, "ibPYPElementType") === ibPYPElementType &&
          !_.get(rating, "isComputedRating") &&
          _.get(rating, "academicCriteriaSet.criteriaType") === type &&
          _.get(rating, "academicCriteriaSet.subType") === "SUBJECT" &&
          _.isNil(_.get(rating, "category.id"))
        );
      }),
      "academicCriteriaValue.label"
    );
  }
);

const _getCategoryWiseAssessmentsTableData = ({
  t,
  students,
  categoryWiseAssessments,
  studentWiseRatings: _studentWiseRatings,
  isCurriculumDP,
  isCurriculumUBD,
  isScoreV2,
  categoryTotalDisplayType,
  tableSortedBy,
}) => {
  const conditionalPercentage =
    categoryTotalDisplayType === "WEIGHT" ? "" : "%";

  const ibPYPElementType = isCurriculumUBD ? "UBD_SUBJECT" : "DP_SUBJECT";

  return _.map(students, student => {
    const { id } = student || {};

    const rowData = [
      {
        key: "student",
        style: styles.studentCell,
        value: getStudentCellData({
          student,
          isCurriculumDP,
          tableSortedBy,
        }),
      },
    ];

    const studentWiseRatings = _.get(
      _.find(_studentWiseRatings, node => node?.id === id),
      "ibPYPElementRatings",
      []
    );

    _.forEach(categoryWiseAssessments, categoryWiseAssessment => {
      const categoryId = _.get(categoryWiseAssessment, "id");
      const assignments = _.get(categoryWiseAssessment, "assignments", []);
      _.forEach(assignments, assignment => {
        const assignmentId = _.get(assignment, "id");
        const assignedStudents = _.get(assignment, "assignedStudents", []);
        const studentAssignment = _.find(
          assignedStudents,
          assignedStudent => _.get(assignedStudent, "student.id") === id
        );

        if (!studentAssignment) {
          rowData.push({
            key: assignmentId,
            value: (
              <Tooltip
                tooltip={t(
                  "progressSummary:student_excluded_from_this_assignment"
                )}
              >
                <div>-</div>
              </Tooltip>
            ),
            style: styles.greyCell,
          });
        } else {
          const value = getStudentAssignmentScore({
            studentWiseRatings,
            studentAssignment,
          });
          rowData.push({ key: assignmentId, value: value ? value : "-" });
        }
      });

      const categoryFinalScore = getCategoryWiseStudentFinalScore({
        studentWiseRatings,
        categoryId,
        ibPYPElementType,
      });

      const isShowGradeBoundaries = _.get(
        categoryWiseAssessment,
        "isShowGradeBoundaries",
        false
      );

      if (isCurriculumDP && isScoreV2 && isShowGradeBoundaries) {
        const categoryFinalGrade = getCategoryWiseStudentFinalGrade({
          studentWiseRatings,
          categoryId,
          ibPYPElementType,
        });

        rowData.push({
          key: `${categoryId}-gradeBoundary`,
          value: categoryFinalGrade,
        });
      }

      rowData.push({
        key: `${categoryId}-total`,
        value: categoryFinalScore
          ? `${_.round(categoryFinalScore, 2)}${conditionalPercentage}`
          : "-",
      });
    });

    const totalsItems = ["FINAL_SCORE"];
    if (isCurriculumDP && isScoreV2) {
      totalsItems.push("FINAL_GRADE");
    }
    if (isScoreV2) {
      totalsItems.push("LOCAL_GRADE");
    }

    _.forEach(totalsItems, type => {
      const params = {
        studentWiseRatings,
        type,
        ibPYPElementType,
      };

      const total = getTotalStudentScore(params);
      let editedFinalGrade;

      if (type === "FINAL_GRADE") {
        editedFinalGrade = getEditedFinalGrade(params);
      }

      let value = total;
      let finalGrade;
      switch (type) {
        case "FINAL_SCORE":
          value = `${_.round(total, 2)}%`;
          break;
        case "FINAL_GRADE": {
          finalGrade = editedFinalGrade ?? total;
          const isOverRidingValue = finalGrade !== total && total !== "-";

          const getFinalGradeTooltip = () => {
            return isOverRidingValue
              ? t(
                  "progressSummary:calculated_grade_with_label_has_been_overridden",
                  { label: total }
                )
              : t("progressSummary:final_grade_has_been_overridden");
          };

          value = (
            <ConditionalWrapper
              condition={!_.isEmpty(editedFinalGrade)}
              wrapper={
                <Tooltip
                  tooltip={getFinalGradeTooltip()}
                  placement="left"
                  overlayInnerStyle={styles.tooltipStyle}
                />
              }
              type={"wrapperAsElement"}
            >
              <div className={classes.finalGradeCon}>
                <span className="text-body-1">{finalGrade}</span>
                {!_.isEmpty(editedFinalGrade) ? (
                  <span className={assignmentTitleSubtextClass}>*</span>
                ) : null}
              </div>
            </ConditionalWrapper>
          );
        }
      }

      rowData.push({
        key: type,
        value: total ? value : "-",
        finalGrade,
      });
    });
    return { id, rowData };
  });
};

export const getCategoryWiseAssessmentsTableData = _.memoize(
  _getCategoryWiseAssessmentsTableData,
  params => JSON.stringify(params)
);

export const getNoCategorySetsFoundText = (t, currentSubjectName) => {
  return currentSubjectName
    ? t("progressSummary:no_category_sets_found_for_label_in_this_term", {
        label: currentSubjectName,
      })
    : t("progressSummary:no_category_sets_found_for_this_subject");
};

export const getNoAssessmentsFoundText = (t, currentSubjectName) => {
  return currentSubjectName
    ? t("progressSummary:no_assessments_created_for_label_in_this_term", {
        label: currentSubjectName,
      })
    : t("progressSummary:no_assessments_created_for_this_subject_in_this_term");
};

export const getIsResponseAdded = ({
  toolResponsesData,
  ibPYPElementRatings,
  assessmentToolType,
  criterias = [],
  objectives = [],
  elementRemarks,
}) => {
  const toolResponses = _.get(
    _.find(toolResponsesData, item => item?.toolType === assessmentToolType),
    "toolResponses",
    []
  );

  switch (assessmentToolType) {
    case "DP_ASSESSMENT_RUBRIC": {
      const rating = _.find(
        ibPYPElementRatings,
        ibPYPElementRating =>
          ibPYPElementRating?.ibPYPElementType === "DP_CRITERIA" &&
          !_.isEmpty(ibPYPElementRating?.value)
      );
      return !_.isEmpty(rating);
    }
    case COMMENT: {
      const comment = getStaffElementRemarkMessage(elementRemarks);
      return !_.isEmpty(comment);
    }

    case "MYP_OBJECTIVE_RUBRIC":
    case "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC": {
      if (!_.isEmpty(criterias) && !_.isEmpty(objectives)) {
        const criteriaAddedInTask = _.filter(objectives, { depth: 2 });
        const criteriaAddedInTaskIds = _.map(criteriaAddedInTask, "id");
        const criteriaRatings = _.filter(ibPYPElementRatings, {
          ibPYPElementType: ELEMENT_TYPE_MYP_OBJECTIVES,
        });
        const criteriaRatingsIds = _.map(criteriaRatings, "ibPYPElementId");

        const allCriteriaRated = _.isEmpty(
          _.difference(criteriaAddedInTaskIds, criteriaRatingsIds)
        );

        return allCriteriaRated && !_.isEmpty(criteriaRatings);
      }

      return !_.isEmpty(toolResponses);
    }
    case SCORE:
    case ASSESSMENT_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY: {
      const rating = _.find(ibPYPElementRatings, ibPYPElementRating => {
        const value = _.get(ibPYPElementRating, "value");
        return (
          ibPYPElementRating?.ibPYPElementType === assessmentToolType &&
          (_.isNumber(value) ? !_.isNil(value) : !_.isEmpty(value))
        );
      });

      return !_.isEmpty(rating);
    }
    case GRADE_SCALE_TOOL: {
      const rating = _.find(ibPYPElementRatings, ibPYPElementRating => {
        const academicCriteriaValue = _.get(
          ibPYPElementRating,
          "academicCriteriaValue"
        );

        return (
          ibPYPElementRating?.ibPYPElementType === assessmentToolType &&
          !_.isEmpty(academicCriteriaValue?.abbreviation)
        );
      });

      return !_.isEmpty(rating);
    }
    case SINGLE_POINT_RUBRIC:
      return _.some(toolResponses, response => {
        return !_.isEmpty(response?.subjectiveResponse);
      });
    case "LEARNING_GOALS": {
      const pypElementTypes = _.values(pypElementMapping);
      const ratings = _.filter(
        ibPYPElementRatings,
        ibPYPElementRating =>
          _.includes(pypElementTypes, ibPYPElementRating?.ibPYPElementType) ||
          _.includes(ibPYPElementRating?.ibPYPElementType, "SUBJECT")
      );
      return !_.isEmpty(ratings);
    }
    default: {
      return !_.isEmpty(toolResponses);
    }
  }
};

const getHeaderLabel = params => {
  const { t, type, maxScore, onClickInfoIcon, infoIconRef } = params || {};

  switch (type) {
    case "SCORE":
      return `${t("common:score")} (/${maxScore})`;
    case ASSESSMENT_GRADE_BOUNDARY:
      return t("common:ib_grade");

    case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
    case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
      return (
        <div style={styles.centerAlignWithGap}>
          {t("common:ib_grade")}
          {onClickInfoIcon ? (
            <IconButton
              icon={<InformationOutlined />}
              variant={"plain"}
              size={"medium"}
              onClick={onClickInfoIcon}
              ref={infoIconRef}
            />
          ) : null}
        </div>
      );

    case "COMMENT":
      return t("common:comment");
    default:
      return "";
  }
};

export const getAssessmentToolHeaders = ({
  t,
  types,
  curriculumType,
  maxScore,
  assignedStudents = [],
  onClickInfoIcon,
  infoIconRef,
  assessmentTools,
}) => {
  const applyWidth = _.size(types) === 1;

  // some subjects does not have subject level genric tags like TOK
  const hasTags = _.every(assignedStudents, assignedStudent => {
    const courseMap = _.get(assignedStudent, "student.courseMap.0.tags");
    return !_.isEmpty(courseMap);
  });

  const headers = [
    {
      key: "student",
      value: t("common:student"),
      style: {
        width: applyWidth ? "196px" : "auto",
      },
    },
  ];

  if (curriculumType === CURRICULUM_TYPE_DP && hasTags) {
    headers.push({
      key: "level",
      value: t("common:level"),
      alignment: "center",
      style: {
        width: applyWidth ? "56px" : "auto",
      },
    });
  }

  const isScore =
    _.size(assessmentTools?.edges) === 1 &&
    _.get(assessmentTools, "edges.0.node.assessmentToolType") === SCORE;
  const headerLabels = _.map(types, type => {
    return {
      key: type,
      value: getHeaderLabel({
        t,
        type,
        maxScore,
        onClickInfoIcon,
        infoIconRef,
      }),
      alignment: isScore ? "center" : "left",
    };
  });

  return [...headers, ...headerLabels];
};

export const getEvaluationStatus = _.memoize(
  ({
    t,
    isArchived,
    isEvaluated,
    isSharedWithStudent,
    isEvaluationApplicable,
  }) => {
    if (isArchived) {
      return t("common:archived");
    }
    if (!getIsEvaluationApplicable(isEvaluationApplicable)) {
      return getIsEnabledExcusedStatusInAssignment()
        ? t("classRoom:excused")
        : t("assessmentEvaluation:evaluation_not_applicable");
    }
    if (isSharedWithStudent) {
      return t("common:shared_with_with_label", { label: t("common:student") });
    }
    if (isEvaluated) {
      return t("assessmentEvaluation:marked_as_evaluated");
    }
    return null;
  },
  params => JSON.stringify(params)
);

export const _getCriteriaNodesForMYPRubric = params => {
  const {
    parentAssessmentToolType,
    criteriaNodes = [],
    interdisciplinaryCriteriaNodes = [],
    objectiveLevelValues = [],
  } = params;

  const isMYPObjectiveRubric =
    parentAssessmentToolType === "MYP_OBJECTIVE_RUBRIC";
  const isMYPInterdisciplinaryRubric =
    parentAssessmentToolType === "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC";

  const isMYPCriteriaRubric =
    isMYPObjectiveRubric || isMYPInterdisciplinaryRubric;

  if (!isMYPCriteriaRubric) return [];

  let criterias = isMYPObjectiveRubric
    ? criteriaNodes
    : interdisciplinaryCriteriaNodes;

  const criteriaNodeParentIds = _.keys(_.keyBy(criterias, "parent"));

  const filterByParent =
    _.size(_.intersection(criteriaNodeParentIds, objectiveLevelValues)) > 0;

  if (filterByParent) {
    criterias = _.filter(criterias, criteria =>
      _.includes(objectiveLevelValues, criteria?.parent)
    );
  }

  criterias = _.orderBy(
    _.uniqBy(
      _.map(criterias, node => {
        return {
          value: node?.value,
          label: node?.label,
        };
      }),
      "label"
    ),
    "label"
  );

  if (_.isEmpty(criterias)) {
    criterias = getCriteriaList({ isIL: isMYPInterdisciplinaryRubric });
  }

  return criterias;
};

export const getCriteriaNodesForMYPRubric = _.memoize(
  params => _getCriteriaNodesForMYPRubric(params),
  params => JSON.stringify(params)
);

const _getCategoryWiseStudentAssessmentsTableHeaders = ({
  isCurriculumDP,
  isCurriculumUBD,
  isCurriculumMYP,
  isScoreV2,
  currentSubjectName,
  t,
  isOverallScoreEnabled,
  isOverallGradeEnabled,
}) => {
  const tableHeaders = [
    {
      key: "title",
      value: t("academicSetup:category_breakdown_with_subject", {
        subject: currentSubjectName,
      }),
    },
  ];

  const isNewAssessmentSettingsEnabled = getIsNewAssessmentSettingsEnabled();

  if (!isNewAssessmentSettingsEnabled || isOverallScoreEnabled) {
    tableHeaders.push({
      key: "total",
      value: t("common:score"),
      style: {
        width: "180px",
      },
    });
  }

  const isCurriculumWithCategoryGrade =
    isCurriculumDP ||
    isCurriculumUBD ||
    (isNewAssessmentSettingsEnabled && isCurriculumMYP);

  const isGradeColumnVisible =
    isCurriculumWithCategoryGrade &&
    isScoreV2 &&
    (!isNewAssessmentSettingsEnabled || isOverallGradeEnabled);

  const gradeColumnHeaderText =
    isCurriculumDP || isCurriculumMYP
      ? t("common:ib_grade")
      : t("common:grade");

  if (isGradeColumnVisible) {
    tableHeaders.push({
      key: "grade",
      value: gradeColumnHeaderText,
      style: {
        width: "180px",
      },
    });
  }
  return tableHeaders;
};

export const getCategoryWiseStudentAssessmentsTableHeaders = _.memoize(
  _getCategoryWiseStudentAssessmentsTableHeaders,
  params => JSON.stringify(params)
);

const _getCategoryWiseStudentAssessmentsTableData = ({
  studentId,
  categoryWiseAssessments,
  studentWiseRatings,
  isCurriculumDP,
  isCurriculumUBD,
  isCurriculumMYP,
  isScoreV2,
  isAbsoluteWeightageType,
  rowToggleState,
  tagId,
  t,
  subjectType,
  categoryFinalScoreCalculationType,
  onClickAssessment,
  curriculumType,
  isOverallScoreEnabled,
  isOverallGradeEnabled,
  isWeightageEnabledForCategory,
  isLocalGradeCalculationEnabled,
}) => {
  const tableData = [];
  let showTermFinalScore = false;

  const ibPYPElementType = getIBPYPElementTypeByCurriculumType({
    curriculumType,
  });
  const isSubjectTypeTOK = subjectType === "TOK";
  const isPercentageCategoryFinalCalculationType =
    categoryFinalScoreCalculationType === "PERCENTAGE";

  const isNewAssessmentSettingsEnabled = getIsNewAssessmentSettingsEnabled();

  const showConditionalPercentage = isNewAssessmentSettingsEnabled
    ? isPercentageCategoryFinalCalculationType
    : !isAbsoluteWeightageType;
  const conditionalPercentage = showConditionalPercentage ? "%" : "";

  const isCurriculumWithGradeColumn =
    isCurriculumDP ||
    (isCurriculumMYP && isNewAssessmentSettingsEnabled) ||
    isCurriculumUBD;

  const isCurriculumWithIBGrade =
    isCurriculumDP || (isCurriculumMYP && isNewAssessmentSettingsEnabled);

  const showAssignmentRows = !isCurriculumUBD || isOverallScoreEnabled;

  _.forEach(categoryWiseAssessments, categoryWiseAssessment => {
    const categoryId = _.get(categoryWiseAssessment, "id");
    const categoryTitle = _.get(categoryWiseAssessment, "label", "");
    const assignments = _.get(categoryWiseAssessment, "assignments", []);
    const scoreValues = _.get(categoryWiseAssessment, "scoreValues");

    const scoreValuePath = isPercentageCategoryFinalCalculationType
      ? "percentageValue"
      : "value";
    const currentScoreValue =
      _.get(
        _.find(scoreValues, ({ genericTag }) => genericTag?.id === tagId),
        scoreValuePath,
        ""
      ) || 0;

    const hasAssignments = !_.isEmpty(assignments);
    const isCategoryExpanded =
      hasAssignments && _.get(rowToggleState, categoryId, false);

    const iconVariant = hasAssignments ? "default" : "subtle";
    const cursorStyle =
      !hasAssignments || !showAssignmentRows ? styles.cursorDefault : {};

    const iconDisabledClass = classNames({
      [studentCategoryClasses.iconDisabled]: !hasAssignments,
    });

    const categoryWeightageText = isWeightageEnabledForCategory
      ? `(${currentScoreValue}${conditionalPercentage})`
      : "";

    const categoryData = [
      {
        key: "title",
        value: (
          <div className={studentCategoryClasses.categoryTitleContainer}>
            <div className={studentCategoryClasses.categoryTitle}>
              {`${categoryTitle} ${categoryWeightageText}`}
            </div>
            {showAssignmentRows ? (
              isCategoryExpanded ? (
                <CaretOpenedFilled />
              ) : (
                <Tooltip
                  tooltip={t("common:no_tasks_added_to_this_category_yet")}
                  placement="top"
                  visible={!hasAssignments}
                >
                  <span className={iconDisabledClass}>
                    <CaretClosedFilled
                      variant={iconVariant}
                      disabled={!hasAssignments}
                    />
                  </span>
                </Tooltip>
              )
            ) : null}
          </div>
        ),
        style: cursorStyle,
      },
    ];

    const showCategoryFinalScore =
      hasAssignments &&
      _.some(assignments, ({ assignedStudents }) =>
        _.get(_.first(assignedStudents), "isSharedWithStudent", false)
      );

    showTermFinalScore |= showCategoryFinalScore;

    const categoryFinalScore = getCategoryWiseStudentFinalScore({
      studentWiseRatings,
      categoryId,
      ibPYPElementType,
    });

    categoryData.push({
      key: "total",
      value: (
        <div>
          <span className={studentCategoryClasses.categoryTotal}>
            {showCategoryFinalScore ? _.round(categoryFinalScore, 2) : "-"}
          </span>
          {showCategoryFinalScore &&
            isPercentageCategoryFinalCalculationType && (
              <span className={studentCategoryClasses.categoryMaxScore}>%</span>
            )}
        </div>
      ),
      style: cursorStyle,
    });

    const isGradeColumnVisible = isCurriculumWithGradeColumn && isScoreV2;

    const criteriaType = isCurriculumUBD ? LOCAL_GRADE : FINAL_GRADE;

    if (isGradeColumnVisible) {
      const categoryFinalGrade = getCategoryWiseStudentFinalGrade({
        studentWiseRatings,
        categoryId,
        ibPYPElementType,
        criteriaType,
      });

      categoryData.push({
        key: "grade",
        value:
          categoryFinalGrade && categoryFinalGrade != "-" ? (
            <div className={studentCategoryClasses.categoryTotal}>
              {categoryFinalGrade}
              {!isSubjectTypeTOK && isCurriculumDP && (
                <span className={studentCategoryClasses.categoryMaxScore}>
                  /{DP_MAX_GRADE}
                </span>
              )}
            </div>
          ) : (
            <div className={studentCategoryClasses.categoryTotal}> - </div>
          ),
        style: cursorStyle,
      });
    }

    const showCategory = _.toNumber(currentScoreValue) > 0 || hasAssignments;
    if (showCategory) {
      tableData.push({
        id: categoryId,
        rowData: categoryData,
        type: "category",
      });
    }

    if (showAssignmentRows) {
      _.forEach(assignments, assignment => {
        const assignmentId = _.get(assignment, "id");
        const courseId = _.get(assignment, "course.id");
        const assignmentTitle = _.get(assignment, "content.title.value", "");
        const { maxScore } = getScoreDetailsMemoize({
          assessmentTools: _.get(assignment, "content.assessmentTools", []),
        });
        const assignedStudents = _.get(assignment, "assignedStudents", []);
        const studentAssignment = _.find(
          assignedStudents,
          assignedStudent => _.get(assignedStudent, "student.id") === studentId
        );

        const isSharedWithStudent = _.get(
          studentAssignment,
          "isSharedWithStudent",
          false
        );

        const value = isSharedWithStudent
          ? getStudentAssignmentValue({
              studentAssignment,
              types: [SCORE],
            })
          : "-";
        const assignmentTotal = value ? value : `-`;

        const rowData = [
          {
            key: "title",
            value: (
              <div
                className={studentCategoryClasses.assignmentTitleContainer}
                onClick={() => {
                  onClickAssessment({ assignmentId, courseId });
                }}
              >
                <div className={classes.dot} />
                <div className={studentCategoryClasses.assignmentTitle}>
                  {assignmentTitle}
                </div>
              </div>
            ),
            style: styles.cursorDefault,
          },
          {
            key: "total",
            value: (
              <div className={studentCategoryClasses.assignmentTotal}>
                {isSharedWithStudent ? (
                  <>
                    {assignmentTotal}
                    <span className={studentCategoryClasses.assignmentMaxScore}>
                      /{maxScore}
                    </span>
                  </>
                ) : (
                  <div className={studentCategoryClasses.unSharedEvaluation}>
                    {t("common:lowercase", {
                      text: t("common:evaluation_not_shared_yet"),
                    })}
                  </div>
                )}
              </div>
            ),
            style: styles.cursorDefault,
          },
        ];

        if (isGradeColumnVisible) {
          const gradeScale = getStudentAssignmentValue({
            studentAssignment,
            types: [
              ASSESSMENT_GRADE_BOUNDARY,
              ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
              ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
              ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
            ],
          });

          rowData.push({
            key: "grade",
            value: (
              <div className={studentCategoryClasses.assignmentTotal}>
                {isSharedWithStudent ? (
                  gradeScale ? (
                    <>
                      {gradeScale}
                      {!isSubjectTypeTOK && (
                        <span
                          className={studentCategoryClasses.assignmentMaxScore}
                        >
                          /{DP_MAX_GRADE}
                        </span>
                      )}
                    </>
                  ) : (
                    "-"
                  )
                ) : (
                  <div className={studentCategoryClasses.unSharedEvaluation}>
                    {t("common:lowercase", {
                      text: t("common:evaluation_not_shared_yet"),
                    })}
                  </div>
                )}
              </div>
            ),
            style: styles.cursorDefault,
          });
        }

        tableData.push({
          id: assignmentId,
          rowData,
          parent: categoryId,
          type: "assignment",
        });
      });
    }
  });

  const totalColumnStyle = { ...styles.cursorDefault, ...styles.greyCell };
  const termTotalScore = getTotalStudentScore({
    studentWiseRatings,
    type: "FINAL_SCORE",
    ibPYPElementType,
  });

  const termTotalPercentageText = isOverallScoreEnabled ? "(100%)" : "";

  const totalData = [];

  if (!isCurriculumUBD || isOverallScoreEnabled) {
    totalData.push({
      key: "title",
      value: (
        <div className={studentCategoryClasses.termTotalTitle}>
          {`${t("common:term_total")} ${termTotalPercentageText}`}
        </div>
      ),
      style: totalColumnStyle,
    });
  }

  if (isOverallScoreEnabled) {
    totalData.push({
      key: "total",
      value: (
        <div className={studentCategoryClasses.termTotalValue}>
          {showTermFinalScore ? _.round(termTotalScore, 2) : "-"}
          {showTermFinalScore ? (
            <span className={studentCategoryClasses.termTotalMaxScore}>%</span>
          ) : null}
        </div>
      ),
      colSpan: isCurriculumUBD ? 2 : 1,
      style: totalColumnStyle,
    });
  }

  if (isCurriculumWithIBGrade && isScoreV2) {
    const termGrade = getTotalStudentScore({
      studentWiseRatings,
      type: "FINAL_GRADE",
      ibPYPElementType,
    });
    const editedFinalGrade = getEditedFinalGrade({
      studentWiseRatings,
      type: "FINAL_GRADE",
      ibPYPElementType,
    });

    const grade = !_.isEmpty(editedFinalGrade) ? editedFinalGrade : termGrade;

    totalData.push({
      key: "grade",
      value:
        grade && grade != "-" ? (
          <div className={studentCategoryClasses.categoryTotal}>
            {grade}
            {!isSubjectTypeTOK ? (
              <span className={studentCategoryClasses.categoryMaxScore}>
                /{DP_MAX_GRADE}
              </span>
            ) : null}
          </div>
        ) : (
          <div className={studentCategoryClasses.categoryTotal}>-</div>
        ),
      style: totalColumnStyle,
    });
  }

  tableData.push({ id: "term-total", rowData: totalData });

  const showLocalGrade = isCurriculumUBD
    ? isOverallGradeEnabled
    : isLocalGradeCalculationEnabled;

  if (isScoreV2 && (!isNewAssessmentSettingsEnabled || showLocalGrade)) {
    const localGrade = getTotalStudentScore({
      studentWiseRatings,
      type: "LOCAL_GRADE",
      ibPYPElementType,
    });

    tableData.push({
      id: "local-grade",
      rowData: [
        {
          key: "title",
          value: (
            <div className={studentCategoryClasses.termTotalTitle}>
              {isCurriculumUBD
                ? t("common:overall_grade")
                : t("common:local_grade")}
            </div>
          ),
          style: totalColumnStyle,
        },
        {
          key: isOverallScoreEnabled ? "total" : "grade",
          value: (
            <div className={studentCategoryClasses.termTotalValue}>
              {localGrade}
            </div>
          ),
          colSpan: 2,
          style: totalColumnStyle,
        },
      ],
    });
  }

  return tableData;
};

export const getCategoryWiseStudentAssessmentsTableData = _.memoize(
  _getCategoryWiseStudentAssessmentsTableData,
  params => JSON.stringify(params)
);

const _getStudentScore = params => {
  const { ibPYPElementRatings = [], assessmentToolType } = params || {};

  const assessmentGradeBoundaryElement = _.find(ibPYPElementRatings, rating => {
    const ibPYPElementType = _.get(rating, "ibPYPElementType");
    const isDeleted = _.get(rating, "isDeleted");
    return ibPYPElementType === assessmentToolType && !isDeleted;
  });

  return assessmentGradeBoundaryElement;
};

export const getStudentScore = _.memoize(
  params => _getStudentScore(params),
  params => JSON.stringify(params)
);

export const getAssessmentToolText = ({ t, type }) => {
  switch (type) {
    case "ASSESSMENT_GRADE_BOUNDARY":
      return t("common:ib_grade");
    case COMMENT:
      return t("common:comment");
    case "DP_ASSESSMENT_RUBRIC":
      return t("classRoom:dp_criteria");
    default:
      return t(_.find(ASSESSMENT_TOOLS, tool => tool?.type === type)?.locale);
  }
};

const getHeaderDropdownMenuOptions = ({
  t,
  overviewList,
  currentPlannerElementSets,
}) => {
  const options = _.reduce(
    overviewList,
    (acc, list) => {
      const { id, localeLabel, children } = list || {};
      const childOptions = _.map(
        children,
        ({ localeLabel, plannerElementType, route, icon }) => ({
          key: route,
          label: _.get(
            currentPlannerElementSets,
            `${plannerElementType}.label`,
            t(localeLabel)
          ),
          icon,
        })
      );

      if (!_.isEmpty(childOptions)) {
        acc.push({
          isItemGroup: true,
          key: id,
          label: t(localeLabel),
          options: childOptions,
        });
      }

      return acc;
    },
    []
  );
  return options;
};

const getCpsHeaderDetails = ({
  t,
  curriculumProgramType,
  currentRoute,
  iconSize = "xxx-small",
  currentPlannerElementSets,
}) => {
  const overviewList = getCurrentCurriculumOverviewList({
    t,
    currentCurriculumType: curriculumProgramType,
    iconSize,
  });

  const headerMenuOptions = getHeaderDropdownMenuOptions({
    t,
    overviewList,
    currentPlannerElementSets,
  });

  const label = getHeaderDropDownLabelValue({
    t,
    options: headerMenuOptions,
    selectedOption: currentRoute,
  });

  return { headerMenuOptions, label };
};

export const getCpsHeaderDetailsMemoized = _.memoize(
  getCpsHeaderDetails,
  params => JSON.stringify(params)
);

export const getSortedStudents = _.memoize(
  ({ unsortedStudents, filterConfig }) => {
    const studentSortConfig = _.find(
      filterConfig,
      config => config?.entity === "STUDENTS"
    );
    return _.orderBy(
      unsortedStudents,
      [
        student =>
          _.toLower(_.get(student, _.camelCase(studentSortConfig?.sortEntity))),
      ],
      [studentSortConfig?.direction]
    );
  }
);

export const getNameSortPreference = _.memoize(({ filterConfig }) => {
  return _.get(
    _.find(filterConfig, config => config?.entity === "STUDENTS"),
    "sortEntity"
  );
});

export const getAllAssessmentsSortOptions = _.memoize(
  ({ t }) => {
    const sortList = [
      {
        key: "FIRSTNAME_AZ",
        label: t("common:first_name_az"),
        sortEntity: "FIRST_NAME",
        direction: "asc",
      },
      {
        key: "FIRSTNAME_ZA",
        label: t("common:first_name_za"),
        sortEntity: "FIRST_NAME",
        direction: "desc",
      },
      {
        key: "MIDDLENAME_AZ",
        label: t("common:middle_name_az"),
        sortEntity: "MIDDLE_NAME",
        direction: "asc",
      },
      {
        key: "MIDDLENAME_ZA",
        label: t("common:middle_name_za"),
        sortEntity: "MIDDLE_NAME",
        direction: "desc",
      },
      {
        key: "LASTNAME_AZ",
        label: t("common:last_name_az"),
        sortEntity: "LAST_NAME",
        direction: "asc",
      },
      {
        key: "LASTNAME_ZA",
        label: t("common:last_name_za"),
        sortEntity: "LAST_NAME",
        direction: "desc",
      },
      {
        key: "FULLNAME_AZ",
        label: t("common:full_name_az"),
        sortEntity: "FULL_NAME",
        direction: "asc",
      },
      {
        key: "FULLNAME_ZA",
        label: t("common:full_name_za"),
        sortEntity: "FULL_NAME",
        direction: "desc",
      },
    ];

    return getUserSortOptions({
      type: "student",
      sortOptions: sortList,
      keyToMap: "sortEntity",
    });
  },
  params => JSON.stringify(params)
);

export const getStudentWiseIBGradeAssessments = _.memoize(
  params => _getStudentWiseIBGradeAssessments(params),
  params => JSON.stringify(params)
);

const _getStudentWiseIBGradeAssessments = ({ data, students }) => {
  const ibGradeData = {};
  const classWiseAverage = {};

  _.forEach(students, student => {
    _.set(ibGradeData, student.id, { student, ibGradeAssessments: [] });
  });

  _.forEach(_.get(data, "assignments.edges", []), edge => {
    const assessmentId = _.get(edge, "node.id", "");
    const assessmentTitle = _.get(edge, "node.content.title.value", "");
    const assessmentType = _.get(edge, "node.content.assessmentType.value", "");

    const classAverage = [];
    const assignedStudents = _.get(edge, "node.assignedStudents", []);

    _.forEach(assignedStudents, assignedStudent => {
      const { student = {}, ibPYPElementRatings = [] } = assignedStudent || {};

      const ibGradeRating = _.find(ibPYPElementRatings, rating =>
        getIsIBGradeScaleTool({
          assessmentToolType: rating?.ibPYPElementType,
        })
      );

      if (
        ibGradeRating &&
        _.get(ibGradeRating, "value") &&
        _.get(ibGradeData, `${student.id}.ibGradeAssessments`)
      ) {
        classAverage.push(parseInt(_.get(ibGradeRating, "value", 0)) || 0);

        ibGradeData[student.id].ibGradeAssessments.push({
          id: assessmentId,
          assessmentTitle,
          assessmentType,
          ibGradeRating,
        });
      }
    });

    if (!_.isEmpty(classAverage)) {
      _.set(classWiseAverage, assessmentId, _.round(_.mean(classAverage), 2));
    }
  });

  return { ibGradeData, classWiseAverage };
};

export const getAllAssessmentsDownloadDropdownOptions = _.memoize(
  ({
    curriculumType,
    t,
    isAllOptionNeeded = false,
    allOptionLabel,
    showGradeScaleOption = false,
  }) => {
    const dropdownOptions = [
      {
        value: "SCORE",
        label: t("common:score"),
      },
      {
        value: "COMMENT",
        label: t("common:final_remarks"),
      },
    ];

    switch (curriculumType) {
      case CURRICULUM_TYPE_DP:
        {
          const options = [
            {
              value: "IB_GRADE",
              label: t("common:ib_grade"),
            },
            {
              value: "DP_ASSESSMENT_RUBRIC",
              label: t("classRoom:dp_criteria"),
            },
          ];
          dropdownOptions.splice(1, 0, ...options);
        }
        break;
      case CURRICULUM_TYPE_MYP: {
        const options = [
          {
            value: "MYP_OBJECTIVE_RUBRIC",
            label: t("common:myp_criteria"),
          },
          {
            value: "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC",
            label: t("common:interdisciplinary_criteria"),
          },
        ];
        dropdownOptions.splice(1, 0, ...options);
      }
    }

    if (showGradeScaleOption) {
      dropdownOptions.push({
        value: "GRADE_SCALE_TOOL",
        label: t("common:grade_scale"),
      });
    }
    if (isAllOptionNeeded) {
      const options = {
        value: "ALL",
        label: allOptionLabel || t("common:all_assessment_tools"),
      };
      dropdownOptions.splice(0, 0, options);
    }
    return dropdownOptions;
  },
  params => JSON.stringify(params)
);

export const getAssessmentToolTypesForDownload = _.memoize(
  values => {
    const IBGradeValues = [
      "ASSESSMENT_GRADE_BOUNDARY",
      "ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY",
      "ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY",
      "ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY",
    ];
    return _.flatten(
      _.map(values, value => (value === "IB_GRADE" ? IBGradeValues : value))
    );
  },
  params => JSON.stringify(params)
);

export const getAssessmentToolTypesByCurriculumType = _.memoize(
  ({ curriculumType }) => {
    switch (curriculumType) {
      case CURRICULUM_TYPE_DP: {
        return [
          "SCORE",
          "COMMENT",
          "DP_ASSESSMENT_RUBRIC",
          "ASSESSMENT_GRADE_BOUNDARY",
          "ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY",
          "ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY",
          "ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY",
        ];
      }
      case CURRICULUM_TYPE_MYP: {
        return [
          "SCORE",
          "COMMENT",
          "MYP_OBJECTIVE_RUBRIC",
          "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC",
        ];
      }
      default: {
        return ["SCORE", "COMMENT"];
      }
    }
  },
  params => JSON.stringify(params)
);

export const getCategoryWiseAssessmentsTermOptions = _.memoize(
  ({ t, terms, currentTermId, groupedTermOptions, curriculumType }) => {
    return curriculumType === CURRICULUM_TYPE_DP
      ? groupedTermOptions
      : _.map(terms, term => {
          const { id, label = "" } = term || {};
          if (id === currentTermId) {
            return {
              ...term,
              label: `${label} (${t("common:current")})`,
            };
          }
          return term;
        });
  },
  params => JSON.stringify(params)
);

export const getRatingTableFilters = ({ state, isGradebook }) => {
  return _.get(
    state,
    isGradebook
      ? "gradebook.learningGoalsFilters"
      : "classProgressSummaryV2.filters",
    {}
  );
};

const dynamicPlannerElementCurriculumTypes = [CURRICULUM_TYPE_UBD];

export const getPlannerElementSetLabel = ({
  curriculumType,
  dynamicLabel,
  localeLabel,
}) => {
  const shouldShowDynamicLabel =
    ACLStore.can("FeatureFlag:ShowPlannerElementCustomLabel") ||
    _.includes(dynamicPlannerElementCurriculumTypes, curriculumType);

  return dynamicLabel && shouldShowDynamicLabel ? dynamicLabel : localeLabel;
};

export const getUpdatedOverviewList = ({
  overviewList,
  plannerElementSets,
  curriculumProgramType,
  t,
}) => {
  const shouldShowDynamicLabel =
    ACLStore.can("FeatureFlag:ShowPlannerElementCustomLabel") ||
    _.includes(dynamicPlannerElementCurriculumTypes, curriculumProgramType);

  return _.map(overviewList, item => {
    if (item.id == "ASSESSMENTS_AND_LEARNING_GOALS") {
      const updatedChildren = _.map(item.children, child => {
        const localeLabel = t(child.localeLabel);

        return {
          ...child,
          label: shouldShowDynamicLabel
            ? _.get(
                plannerElementSets,
                `${child?.plannerElementType}.label`,
                localeLabel
              )
            : localeLabel,
        };
      });
      return { ...item, children: updatedChildren };
    }
    return item;
  });
};
const regexHelper = ({ searchText }) =>
  createRegex({ text: searchText ?? "", flags: "gi" });

export const getLabelWithCodeOrArchived = ({
  label,
  code,
  labelClass,
  codeClass,
  containerClass,
  isArchived,
  shouldDangerouslyInjectLabel,
  t,
}) => {
  return isArchived
    ? getLabelWithArchivedText({
        label,
        isArchived,
        t,
        shouldDangerouslyInjectLabel,
      })
    : getSubjectStandardWithCode({
        label,
        code,
        shouldDangerouslyInjectLabel,
        labelClass,
        codeClass,
        containerClass,
      });
};

export const getHTMLCellLabel = ({
  label,
  searchText,
  style = {},
  isArchived = false,
  code,
  t,
}) => {
  return ReactDOMServer.renderToStaticMarkup(
    getLabelWithCodeOrArchived({
      label:
        !searchText || !label
          ? label
          : label.replace(regexHelper({ searchText }), val => {
              return ReactDOMServer.renderToStaticMarkup(
                <b style={style}>{val}</b>
              );
            }),
      isArchived,
      t,
      code,
      shouldDangerouslyInjectLabel: true,
    })
  );
};

export const getProgressReportsDropdownOptions = ({
  publishedReportBasicDetails,
}) => {
  const progressReportsOfAllStudents = _.unionBy(
    ..._.map(
      publishedReportBasicDetails,
      report => report.publishedProgressReports
    ),
    "studentProgressReport.courseProgressReportTask.progressReportTaskGroup.id"
  );

  const filteredPublishedReportsOfAllStudents = _.filter(
    progressReportsOfAllStudents,
    publishedProgressReport =>
      _.get(
        publishedProgressReport,
        "studentProgressReport.courseProgressReportTask.progressReportTaskGroup.template.gradingPeriodType",
        "REPORTING"
      ) != "CUMULATIVE"
  );

  const progressReportsDropdownOptions = _.map(
    filteredPublishedReportsOfAllStudents,
    report => ({
      key: _.get(
        report,
        "studentProgressReport.courseProgressReportTask.progressReportTaskGroup.id",
        ""
      ),
      label: _.get(
        report,
        "studentProgressReport.courseProgressReportTask.title"
      ),
      id: _.get(report, "id", ""),
    })
  );

  return progressReportsDropdownOptions;
};

export const getReportsToStudentMapping = _.memoize(
  ({ publishedReportBasicDetails }) => {
    return _.reduce(
      publishedReportBasicDetails,
      (result, student) => {
        const { id } = student;
        _.forEach(student.publishedProgressReports, report => {
          const reportId = _.get(
            report,
            "studentProgressReport.courseProgressReportTask.progressReportTaskGroup.id",
            ""
          );
          if (result[reportId]) {
            result[reportId].push(id);
          } else {
            result[reportId] = [id];
          }
        });
        return result;
      },
      {}
    );
  },
  params => JSON.stringify(params)
);

export const getIBPYPElementTypeByCurriculumType = _.memoize(
  ({ curriculumType }) => {
    let elementTypePrefix = "";
    switch (curriculumType) {
      case CURRICULUM_TYPE_DP:
        elementTypePrefix = "DP";
        break;
      case CURRICULUM_TYPE_UBD:
        elementTypePrefix = "UBD";
        break;
      case CURRICULUM_TYPE_MYP:
        elementTypePrefix = "MYP";
        break;
      case CURRICULUM_TYPE_PYP:
        elementTypePrefix = "PYP";
        break;
    }

    return `${elementTypePrefix}_SUBJECT`;
  },
  params => JSON.stringify(params)
);

export const getSubjectListByCurriculum = ({
  curriculumType,
  courseDetails,
  selectedClassGrades,
}) => {
  switch (curriculumType) {
    case CURRICULUM_TYPE_UBD: {
      return _.orderBy(
        _.get(courseDetails, "subjects", []),
        ["isArchived"],
        ["asc"]
      );
    }
    default: {
      return _.orderBy(
        _.get(
          getUniqlyCombinedGradesDetails(selectedClassGrades),
          "subjects",
          []
        ),
        ["isArchived"],
        ["asc"]
      );
    }
  }
};

export const SCORE_COMMENT_IB_GRADE = [
  "SCORE",
  "ASSESSMENT_GRADE_BOUNDARY",
  "COMMENT",
  "COMBINED_TOOLS",
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
];

export const getElementRatingsFromAssignedStudents = ({
  assessmentTools,
  assignedStudents,
  maxScore,
  ibGradeScale,
  autoIBGradeScaleToolItem,
  userId,
  sourceFrom,
  isAiEvaluationEnabled,
}) => {
  const elementRatingsMap = {};
  const elementRatingsFromQuery = [];

  const assessmentToolTypes = _.map(assessmentTools?.edges, ({ node }) => {
    return _.get(node, "assessmentToolType");
  });

  const tools = _.intersection(assessmentToolTypes, SCORE_COMMENT_IB_GRADE);

  _.forEach(tools, tool => {
    const ibPYPElementRatingsLocal = _.map(
      assignedStudents,
      assignedStudent => {
        const rating = _.find(
          _.get(assignedStudent, "ibPYPElementRatings", []),
          ibPYPElementRating => {
            return (
              ibPYPElementRating?.ibPYPElementType === tool &&
              !ibPYPElementRating?.isDeleted
            );
          }
        );

        const isIBGradeScale = getIsIBGradeScaleTool({
          assessmentToolType: tool,
        });

        const isComment = tool === "COMMENT";
        const isScore = tool === "SCORE";

        const { isEvaluated = false } = assignedStudent || {};

        const shouldSkip = isScore && _.isEmpty(maxScore);

        const commentValue = getStaffElementRemarkMessage(
          _.get(assignedStudent, "elementRemarks", []),
          isAiEvaluationEnabled
        );
        const _ibGradeScale =
          tool === "ASSESSMENT_GRADE_BOUNDARY"
            ? ibGradeScale
            : autoIBGradeScaleToolItem;

        return {
          value: isComment ? commentValue : _.get(rating, "value"),
          studentId: _.get(assignedStudent, "student.id"),
          parentId: _.get(assignedStudent, "id"),
          parentType: "STUDENT_ASSIGNMENT",
          ibPYPElementId: isIBGradeScale
            ? _.get(_ibGradeScale, "id")
            : undefined,
          ibPYPElementType: isComment ? "STUDENT_ASSIGNMENT" : tool,
          isPublished: isEvaluated,
          createdBy: userId,
          academicCriteriaSetId: isIBGradeScale
            ? _.get(_ibGradeScale, "id")
            : "-9999",
          academicCriteriaValueId: isIBGradeScale
            ? _.get(rating, "academicCriteriaValue.id")
            : "-9999",
          shouldSkip,
          source: sourceFrom,
        };
      }
    );

    if (!elementRatingsMap[tool]) {
      elementRatingsMap[tool] = [];
    }

    elementRatingsMap[tool]?.push(...ibPYPElementRatingsLocal);
    elementRatingsFromQuery.push(...ibPYPElementRatingsLocal);
  });

  return { elementRatingsMap, elementRatingsFromQuery };
};
